import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { CampaignMaintenanceService } from 'src/app/pages/maintenance/campaign-maintenance/campaign-maintenance.service';
import { PATTERN_ALPHA_NUMERIC_WITH_SPACE, PATTERN_NUMERIC, SMS_DEFAULT_REGISTRATION_SUCCESS, SMS_DEFAULT_USER_ALREADY_REGISTERED, SMS_DEFAULT_ANOTHER_USER_REGISTERED, SMS_DEFAULT_USER_MAXED_COUPON, SMS_PRICE } from 'src/app/utils/constant';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { S3Service } from 'src/app/services';
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'esc-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss']
})
export class StepOneComponent implements OnInit {
  @Input() campaignData;
  @Input() isDisabled;
  @Input() loadingCampaign;
  @Input() viewMode;
  @Input() editMode;
  @Input() status;

  public minDate = new Date(moment().add(1, 'd').toDate());

  private defaultSMSMessages = [
    {
      type: "REGISTRATION_SUCCESS",
      message: SMS_DEFAULT_REGISTRATION_SUCCESS
    },
    {
      type: "USER_ALREADY_REGISTERED",
      message: SMS_DEFAULT_USER_ALREADY_REGISTERED
    },
    {
      type: "ANOTHER_USER_REGISTERED",
      message: SMS_DEFAULT_ANOTHER_USER_REGISTERED
    },
    {
      type: "USER_MAXED_COUPON",
      message: SMS_DEFAULT_USER_MAXED_COUPON
    },
  ]
  
  constructor(
    private s3: S3Service,
    private fb: FormBuilder,
    public cmpMntService: CampaignMaintenanceService,
  ) { }
 
  public formGroup: FormGroup;
 
  ngOnInit() {
    this.initForm();
  }
  
  initForm() {
    this.formGroup = this.fb.group({
      code: [{value: null, disabled: true}],
      description: [null, [Validators.required, Validators.maxLength(250)]],
      reference_filename: [null, [Validators.required]],
      start_date: [null, Validators.required],
      end_date: [null, Validators.required],
      reversal_number_of_days: [null, [Validators.required, Validators.min(1), Validators.pattern(PATTERN_NUMERIC), Validators.maxLength(3)]],
      registration_success: [SMS_DEFAULT_REGISTRATION_SUCCESS, Validators.required],
      user_already_registered: [SMS_DEFAULT_USER_ALREADY_REGISTERED, Validators.required],
      another_user_registered: [SMS_DEFAULT_ANOTHER_USER_REGISTERED, Validators.required],
      user_maxed_coupon: [SMS_DEFAULT_USER_MAXED_COUPON, Validators.required]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.campaignData && changes.campaignData.currentValue) {
      this.formGroup.get('code').setValue(_.get(changes.campaignData, 'currentValue.code'));
      this.formGroup.get('description').setValue(_.get(changes.campaignData, 'currentValue.description'));
      this.formGroup.get('reference_filename').setValue(_.get(changes.campaignData, 'currentValue.reference_filename'));
      
      const startDatePath = 'currentValue.start_date';
      const endDatePath = 'currentValue.end_date';
          
      const startDateExists = _.has(changes.campaignData, startDatePath);
      const endDateExists = _.has(changes.campaignData, endDatePath);
          
      const startDate = startDateExists ? _.get(changes.campaignData, startDatePath) : null;
      const endDate = endDateExists ? _.get(changes.campaignData, endDatePath) : null;
          
      if (startDate === null) {
        this.formGroup.get('start_date').setValue(null);
      } else if (typeof startDate === 'string' || typeof startDate === 'number' || startDate instanceof Date) {
        this.formGroup.get('start_date').setValue(new Date(startDate));
      } else {
        this.formGroup.get('start_date').setValue(null);
      }
      
      if (endDate === null) {
        this.formGroup.get('end_date').setValue(null);
      } else if (typeof endDate === 'string' || typeof endDate === 'number' || endDate instanceof Date) {
        this.formGroup.get('end_date').setValue(new Date(endDate));
      } else {
        this.formGroup.get('end_date').setValue(null);
      }

      this.formGroup.get('reversal_number_of_days').setValue(_.get(changes.campaignData, 'currentValue.reversal_number_of_days'));
      
      this.formGroup.get('registration_success').setValue(this.getSmsMessage(_.get(changes.campaignData, 'currentValue.campaign_sms_message'), "registration_success"))
      this.formGroup.get('user_already_registered').setValue(this.getSmsMessage(_.get(changes.campaignData, 'currentValue.campaign_sms_message'), "user_already_registered"))
      this.formGroup.get('another_user_registered').setValue(this.getSmsMessage(_.get(changes.campaignData, 'currentValue.campaign_sms_message'), "another_user_registered"))
      this.formGroup.get('user_maxed_coupon').setValue(this.getSmsMessage(_.get(changes.campaignData, 'currentValue.campaign_sms_message'), "user_maxed_coupon"))

      if (this.isDisabled) {
        this.formGroup.disable({emitEvent: false})
      }

      if(_.toLower(this.status) == "ongoing" && this.editMode) {
        this.formGroup.get('code').disable({emitEvent: false})
      }
    } else if (this.formGroup) {
      this.formGroup.reset();
      
    /* always disable step 1 as per issue #359
    * kiko - fix applied 5/28/2020
    */
      // this.formGroup.get('reference_filename').enable();
      // this.formGroup.get('start_date').enable();
      // this.formGroup.get('end_date').enable();
      // this.formGroup.get('reversal_number_of_days').enable();
    }
  }

  computeSmsFee(ctrlLength: 0) {
    return (Math.ceil(ctrlLength / 160) * SMS_PRICE) > 0 ? (Math.ceil(ctrlLength / 160) * SMS_PRICE).toFixed(2) : 0;
  }

  getSmsMessage(data, key) {
    if(_.size(data) > 0) {
      return _.find(data, e => _.toUpper(e.type) == _.toUpper(key)).message
    }
    else {
      return _.find(this.defaultSMSMessages, e => _.toUpper(e.type) == _.toUpper(key)).message
    }
  }
}